import * as React from 'react';

import AudienceModalGraphicSvg from './audience-modal-graphic.svg';

import styles from './audience-modal-graphic.module.css';

export class AudienceModalGraphic extends React.PureComponent<Record<any, any>> {
    render() {
        return (
            <div className={styles.container}>
                <AudienceModalGraphicSvg />
            </div>
        );
    }
}
